/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { Link} from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { YEAR } from '../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import {decode} from 'html-entities';
import Fade from 'react-reveal/Fade';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import {API_UPLOADS} from "../../api";
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

const Screen = ({footer, faq, privacy, setting}) => {

	return (
		<>
			<div className="_footer_container" style={{backgroundColor: '#F8F9FA'}}>
				<div className="_footer">
					<div className="_container">
						<Fade top cascade>
							<div className="_row_auto">
								<div className="_column_auto">
									<div className="_push_t_d">
										{
											setting.logo &&
											<Fade top cascade>
												<img width="150" style={{marginLeft: 0}} src={API_UPLOADS + setting.logo} alt="logo" />
											</Fade>
										}
									</div>
								</div>
								<div className="_column_auto_2">
									<Fade top cascade>
										<h3 className="_push_t_g">Alamat</h3>
									</Fade>
									{
										footer&&
										<>
											<p className="_push_t_l _push_b_d">{decode(footer[0].address)}</p>
											<a href={'https://maps.google.com?q=' + decode(footer[0].map)} className="_btn _push_r_s" style={{borderRadius: 32}}>Map</a>
											<a href="/mail" className="_btn" style={{borderRadius: 32}}>Message</a>
										</>
									}
								</div>
								<div className="_column_auto">
									<Fade top cascade>
										<h3 className="_push_t_g">Hubungi Kami</h3>
									</Fade>
									<div className="_push_t_l">
										<ul>
											<li>
												<ion-icon name="call-outline" style={{fontSize: 20, marginRight: 8}}></ion-icon>
												<span> {footer&&footer[0].phone}</span>
											</li>
											<li>
												<ion-icon name="mail-outline" style={{fontSize: 20, marginRight: 8}}></ion-icon>
												<span> {footer&&footer[0].email}</span>
											</li>
										</ul>
									</div>
									{
										footer &&
										<div className="_sosmed">
											{footer[0].facebook !== '' &&
												<a href={decode(footer[0].facebook)}>
													<ion-icon name="logo-facebook"></ion-icon>
												</a>
											}
											{footer[0].instagram !== '' &&
												<a href={decode(footer[0].instagram)}>
													<ion-icon name="logo-instagram"></ion-icon>
												</a>
											}
											{footer[0].twitter !== '' &&
												<a href={decode(footer[0].twitter)}>
													<ion-icon name="logo-twitter"></ion-icon>
												</a>
											}
											{footer[0].youtube !== '' &&
												<a href={decode(footer[0].youtube)}>
													<ion-icon name="logo-youtube"></ion-icon>
												</a>
											}
										</div>
									}
								</div>
								<div className="_column_auto">
									<Fade top cascade>
										<h3 className="_push_t_g">Help</h3>
									</Fade>
									{
										privacy &&
										<div className="_push_t_l">
											<ul>
												<li>
													<ion-icon name="document-outline" style={{fontSize: 20, marginRight: 8}}></ion-icon>
													<Link to={"/pages/" + faq[0].slug}>{decode(faq[0].title)}</Link>
												</li>
												<li>
													<ion-icon name="umbrella-outline" style={{fontSize: 20, marginRight: 8}}></ion-icon>
													<Link to={"/pages/" + privacy[0].slug}>{decode(privacy[0].title)}</Link>
												</li>
											</ul>
										</div>
									}
								</div>
							</div>
							
						</Fade>
					</div>
				</div>
				<div className="_container _relative">
					<div>
						<div className="_row_auto">
							<div className="_column_auto">
								<p className="_font_size_14px">©{YEAR}. {decode(footer&&footer[0].credit)}</p>
							</div>
							<div className="_column_auto _right_text">
								<p className="_font_size_14px">Created By <a href="https://flamecore.cloud"><b>Flamecore Cloud</b></a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Screen;